var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeartEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M22.5 8.706a6.336 6.336 0 0 1-1.746 4.388l-8.12 8.126a.892.892 0 0 1-1.296 0l-8.092-8.126C.918 10.67.918 6.74 3.246 4.318s6.102-2.423 8.43 0l.324.337.323-.337A5.843 5.843 0 0 1 16.538 2.5c1.582 0 3.098.654 4.216 1.818A6.336 6.336 0 0 1 22.5 8.706zm-3.186 3.354c.76-.83 1.32-2.149 1.32-3.323 0-1.175-.56-2.3-1.32-3.13a3.876 3.876 0 0 0-2.867-1.284c-1.074 0-2.099.453-2.858 1.283l-.953 1.043a.846.846 0 0 1-1.272 0l-.953-1.043c-1.581-1.729-4.342-1.729-5.923 0-.73.799-1.15 1.86-1.205 2.95-.066 1.27.552 2.573 1.403 3.504l6.97 6.75a.5.5 0 0 0 .692.003l6.012-5.71.954-1.043z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartEmpty);
export default __webpack_public_path__ + "static/media/icon-heart-empty.baeb4268.svg";
export { ForwardRef as ReactComponent };